import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import * as types from 'constants/ActionTypes';

import * as checkListAdviceStatsActions from '../actions/categoriesStatisticsActions';
import { fetchReduce } from '../modules/statistics/sagas';

function* fetchCategoryStatsDistribution({ payload }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsDistributionSuccess(data));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsDistributionFailure(error));
  }
}

function* fetchCategoriesStatsRevenue({ payload }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsRevenueSuccess(data));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsRevenueFailure(error));
  }
}

function* fetchCategoriesStatsContributor({ payload }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsContributorSuccess(data));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsContributorFailure(error));
  }
}

function* fetchCategoriesStatsContributorTopAuthorWorker({ payload, meta }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsContributorTopAuthorSuccess(data, meta));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsContributorTopAuthorFailure(error, meta));
  }
}

function* fetchCategoriesStatsContributorTopSenderWorker({ payload, meta }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsContributorTopSenderSuccess(data, meta));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchCategoriesStatsContributorTopSenderFailure(error, meta));
  }
}

function* fetchStatisticSeverity({ payload, meta }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    const { content: stats } = data;
    yield put(checkListAdviceStatsActions.fetchStatisticSeveritySuccess(stats, meta));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchStatisticSeverityFailure(error, meta));
  }
}

function* fetchStatisticTopAnything({ payload, meta }) {
  const { request } = payload;
  try {
    const data = yield fetchReduce(request);
    const { content: stats = [] } = data;
    yield put(checkListAdviceStatsActions.fetchTopAnythingSuccess(stats[0], meta));
  } catch (error) {
    yield put(checkListAdviceStatsActions.fetchTopAnythingFailure(error, meta));
  }
}

export default function* categoriesStatisticsSagas() {
  yield takeLatest([types.FETCH_CATEGORIES_STATS_REVENUE_REQUEST], fetchCategoriesStatsRevenue);
  yield takeLatest([types.FETCH_CATEGORIES_STATS_DISTRIBUTION_REQUEST], fetchCategoryStatsDistribution);
  yield takeLatest([types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_REQUEST], fetchCategoriesStatsContributor);
  yield takeLatest([types.FETCH_STATISTICS_SEVERITY], fetchStatisticSeverity);
  yield takeEvery([types.FETCH_STATISTICS_TOP_ANYTHING], fetchStatisticTopAnything);

  yield takeLatest(
    [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_AUTHOR_REQUEST],
    fetchCategoriesStatsContributorTopAuthorWorker
  );
  yield takeLatest(
    [types.FETCH_CATEGORIES_STATS_CONTRIBUTOR_TOP_SENDER_REQUEST],
    fetchCategoriesStatsContributorTopSenderWorker
  );
}
